import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { OrganizationPollsData, OrganizationPollsState } from './types'

const initialState: OrganizationPollsState = {}

const organizationPollsSlice = createSlice({
  name: 'organizationPolls',
  initialState,
  reducers: {
    setOrganizationPollsData: (
      state,
      action: PayloadAction<{ organizationId: string; data: OrganizationPollsData }>
    ) => {
      state[action.payload.organizationId] = action.payload.data
    },
    setOrganizationPollsError: (state, action: PayloadAction<string>) => {
      state[action.payload] = 'error'
    },
    setOrganizationPollsPending: (state, action: PayloadAction<string>) => {
      state[action.payload] = 'pending'
    },
  },
})

export const { setOrganizationPollsData, setOrganizationPollsError, setOrganizationPollsPending } =
  organizationPollsSlice.actions

export default organizationPollsSlice.reducer
